import request from '@/utils/request'

// 修改当前用户信息
export function editInfoApi(data) {
    return request({
        url: '/agent/personal/edit-info',
        method: 'post',
        data
    })
}

// 重置密码
export function resetPSApi(data) {
    return request({
        url: '/agent/personal/reset-password',
        method: 'post',
        data
    })
}

// 上传文案二维码
export function updateImageUrl(data) {
    return request({
        url: '/common/upload/image',
        method: 'post',
        isFormData: true,
        data: {
            ...data
        },
    })
}



// WEBPACK FOOTER //
// ./src/api/editInfo.js